const $inject = ['$state', 'lbDialogService'];

const locationService = function ($state, lbDialogService) {
  const searchDefaults = {
    Hotel: 0,
    Car: 0,
    Rail: 0,
    Flight: 0,
    GroundTransport: 0,
  };

  let service = {
    currentSearchType: undefined,
    searchIndex: searchDefaults,
    reset: reset,
    updateCurrentSearchType: updateCurrentSearchType,
    getCurrentSearchType: getCurrentSearchType,
    increaseSearchIndex: increaseSearchIndex,
    nextPage: nextPage,
    gotoSection: gotoSection,
    cancelBooking: cancelBooking,
    getCurrentSearchSegment,
  };

  const sessionSearchIndex = JSON.parse(sessionStorage.getItem('locationService:searchIndex'));

  if (sessionSearchIndex) {
    service.searchIndex = sessionSearchIndex;
  }

  function reset() {
    service.currentSearchType = undefined;
    service.searchIndex = searchDefaults;

    sessionStorage.removeItem('locationService:currentSearchType');
    sessionStorage.removeItem('locationService:searchIndex');
  }

  function updateCurrentSearchType(type) {
    service.currentSearchType = type;
    sessionStorage.setItem('locationService:currentSearchType', service.currentSearchType);
  }

  function getCurrentSearchType() {
    if (service.currentSearchType) {
      return service.currentSearchType;
    }
    const sessionServiceType = sessionStorage.getItem('locationService:currentSearchType');
    service.currentSearchType = sessionServiceType;
    return sessionServiceType;
  }

  function increaseSearchIndex(type, increment) {
    increment = increment || 1;

    let newIndex = service.searchIndex[type] + increment;

    setSearchIndex(type, newIndex);
  }

  function setSearchIndex(type, value) {
    service.searchIndex[type] = value;
    sessionStorage.setItem('locationService:searchIndex', JSON.stringify(service.searchIndex));
  }

  function nextPage(searchObj, selectedItems) {
    const searchTypes = searchObj.SearchTypes;
    let type = service.currentSearchType;
    let nextType = type;
    if (type) {
      const searchTypeCompleted = searchObj[`${type}s`].length === service.searchIndex[type];

      if (searchTypeCompleted) {
        setSearchIndex(type, 0);

        let searchTypeIndex = searchTypes.indexOf(type);
        let nextSearchTypeIndex = searchTypeIndex + 1;

        if (nextSearchTypeIndex < searchTypes.length) {
          nextType = searchTypes[nextSearchTypeIndex];
        } else {
          nextType = 'Itinerary';
        }
      }
    } else {
      nextType = searchObj.SearchTypes[0];
      if (!searchObj[`${nextType}s`].length) {
        console.warn('NO NEXTPAGE FOUND!');
        return;
      }
    }

    gotoSection(nextType, selectedItems);
  }

  function gotoSection(section, selectedItems) {
    if (section == 'Itinerary') {
      const msie = document.documentMode;

      if (msie === 9) {
        window.location.href = '/#/itinerary';
        location.reload(true);
      } else {
        $state.go('app.itinerary', {}, { reload: true });
      }
      return;
    }
    switch (section) {
      case 'Flight':
        $state.go('app.booking.segment.flights', { selectedItems: selectedItems }, { reload: true });
        break;
      case 'Rail':
        $state.go('app.booking.segment.rail', {}, { reload: true });
        break;
      case 'Hotel':
        $state.go('app.booking.segment.hotels', {}, { reload: true });
        break;
      case 'GroundTransport':
        $state.go('app.booking.segment.groundtransportation', {}, { reload: true });
        break;
      case 'Car':
        $state.go('app.booking.segment.cars', {}, { reload: true });
        break;
      default:
        service.reset();
        console.warn('NO NEXTPAGE FOUND!');
    }
  }

  function cancelBooking(isModification = false) {
    let dialogOptions = {
      title: isModification ? 'This will cancel the current modifications' : 'This will cancel the existing booking.',
      message: 'Are you sure you want to do this?',
      warningLevel: 'warning',
      submitButtonText: 'OK',
    };

    lbDialogService.show(dialogOptions).then(function () {
      $state.go('app.home');
    });
  }

  function getCurrentSearchSegment(search) {
    const currentSearchType = service.getCurrentSearchType();
    const currentSearchIndex = service.searchIndex[currentSearchType];

    return search[`${currentSearchType}s`][currentSearchIndex];
  }

  return service;
};

locationService.$inject = $inject;

export default locationService;



// WEBPACK FOOTER //
// ./src/services/locationService.js